// Copyright (c) 2020 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

export const USER_GUIDE_DOC = 'https://docs.kepler.gl/docs/user-guides';
export const ACTIONS_DOC = 'https://docs.kepler.gl/docs/api-reference/actions/actions';
export const API_REFERENCE_DOC = 'https://docs.kepler.gl/docs/api-reference';

export const EXPORT_HTML_MAP_DOC = `${USER_GUIDE_DOC}/k-save-and-export`;
export const ADD_DATA_TO_MAP_DOC = `${ACTIONS_DOC}#adddatatomap`;
export const MAPBOX_ACCESS_TOKEN = 'https://docs.mapbox.com/help/how-mapbox-works/access-tokens/';

export const EXPORT_HTML_MAP_MODES_DOC = `${USER_GUIDE_DOC}/k-save-and-export#export-html-map`;
export const GUIDES_FILE_FORMAT_DOC = `${USER_GUIDE_DOC}/b-kepler-gl-workflow/a-add-data-to-the-map#supported-file-formats`;
export const BUG_REPORT_LINK =
  'https://github.com/keplergl/kepler.gl/issues/new?assignees=&labels=bug&template=bug_report.md&title=%5BBug%5D';
